// extracted by mini-css-extract-plugin
export default {"copybutton":"fda86441a4a6f792ac91","copier":"b346757645aebafb002b","sign":"a4d5ebd60079ef98e3fd"};